<!-- 用于弹出层刻度尺组件 -->
<template>
  <van-popup
    v-model="show"
    round
    position="bottom"
    @closed="bindClose"
    :lock-scroll="false"
  >
    <div class="container" v-if="show">
      <div class="close iconfont icon-cha" @click="bindClose"></div>
      <div class="title">选择你的身高体重</div>
      <div class="desc">请填写真实信息，确保方案的专业性</div>
      <div class="height-content">
        <div class="gender-container"
          ><img class="gender" :src="genderImage[gender]" alt=""
        /></div>
        <div class="height-unit">
          <div class="num">{{ curHeight }}</div>
          <div class="unit">CM</div>
        </div>
        <RulerVer
          class="ruler-ver"
          :maxNum="maxNumHeight"
          :minNum="minNumHeight"
          :NowNum="defaultHeight"
          @post-NumValue="bindChangeHeight"
        />
      </div>
      <div class="content">
        <div class="value">
          <span class="number">{{ curWeight }}</span>
          <span class="unit">KG</span>
        </div>
        <MyRuler
          style="margin-bottom: 48px"
          @change="bindChangeWeight"
          :NowNum="defaultWeight"
          :maxNum="maxNumWeight"
          theme="#81EF5F"
          :minNum="minNumWeight"
        />
        <div class="btn-content">
          <div class="btn-item confirm" @click="bindConfirm">选好了</div>
        </div>
      </div>
    </div>
  </van-popup>
</template>
<script>
import MyRuler from '@/components/app/ruler/ruler.vue'
import RulerVer from '@/components/app/ruler/ruler-ver.vue'
export default {
  components: {
    MyRuler,
    RulerVer
  },
  props: {
    gender: {
      type: Number,
      default: 1
    },
    value: {
      //是否显示popup
      type: Boolean,
      default: false
    },
    height: {
      type: Number,
      default: 160
    },
    weight: {
      type: Number,
      default: 60
    }
  },
  data() {
    return {
      maxNumHeight: 230,
      minNumHeight: 100,
      maxNumWeight: 200,
      minNumWeight: 30,
      show: false,
      defaultHeight: 160,
      curHeight: 0,
      defaultWeight: 0,
      curWeight: 0,
      genderImage: {
        1: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/708cda10c03b96d0877976a1b4cc6ac9.png',
        2: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/e0e98dc48a0fa7ea6f766052b43870bc.png'
      }
    }
  },
  watch: {
    value() {
      this.show = this.value
    },
    height() {
      this.defaultHeight = this.height || 160
    },
    weight() {
      this.defaultWeight = this.weight || 60
    }
  },
  computed: {},
  created() {
    this.show = this.value
    this.defaultHeight = this.height || 160
    this.defaultWeight = this.weight || 60
    this.curHeight = this.height
    this.curWeight = this.weight
  },
  mounted() {},
  methods: {
    bindChangeWeight(value) {
      this.curWeight = value
    },
    bindChangeHeight(value) {
      this.curHeight = value
    },
    bindClose() {
      this.$emit('input', false)
    },
    bindConfirm() {
      this.$emit('confirm', { height: this.curHeight, weight: this.curWeight })
      this.bindClose()
    }
  }
}
</script>
<style lang="scss" scoped>
.van-popup--round {
  border-radius: 8px 8px 0px 0px;
}

.container {
  background: #ffffff
    linear-gradient(187deg, #ebfedf 0px, rgba(255, 255, 255, 0) 100px);
  border-radius: 16px 16px 0px 0px;
  padding: 20px 20px 56px;
  position: relative;

  .close {
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    color: rgba(0, 0, 0, 0.3);
    position: absolute;
    right: 10px;
    top: 10px;
  }

  .title {
    text-align: center;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    font-size: 20px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.8);
    line-height: 28px;
    margin-bottom: 6px;
  }

  .desc {
    text-align: center;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.5);
    line-height: 20px;
    margin-bottom: 46px;
  }

  .height-content {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .gender-container {
      flex: 1;
      flex-shrink: 0;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;

      .gender {
        width: 86px;
        height: 254px;
      }
    }

    .height-unit {
      width: 56px;
      white-space: nowrap;
      margin-right: 9px;
      .num {
        font-size: 30px;
        font-family: DINPro-Bold, DINPro;
        font-weight: bold;
        color: #0d0d0d;
        line-height: 30px;
      }

      .unit {
        text-align: right;
        font-size: 12px;
        font-family: DINPro-Medium, DINPro;
        font-weight: 500;
        color: #0d0d0d;
        line-height: 18px;
      }
    }

    .ruler-ver {
      width: 70px;
      height: 254px;
    }
  }

  .content {
    text-align: center;

    .value {
      margin-bottom: 10px;

      .number {
        text-align: right;
        min-width: 65px;
        white-space: nowrap;
        display: inline-block;
        font-size: 32px;
        font-family: DINAlternate-Bold, DINAlternate;
        font-weight: bold;
        color: #0d0d0d;
        line-height: 37px;
        letter-spacing: 1px;
        margin-right: 10px;
      }

      .unit {
        font-size: 14px;
        font-family: DINAlternate-Bold, DINAlternate;
        font-weight: bold;
        color: #0d0d0d;
        line-height: 16px;
      }
    }
  }
}

.btn-content {
  padding: 0px 32px;
  display: flex;
  align-items: center;
  justify-content: center;

  .btn-item {
    text-align: center;
    width: 160px;
    height: 42px;
    line-height: 42px;
    background: #0d0d0d;
    border-radius: 21px;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
  }
}
</style>
